module.exports = __webpack_public_path__ + "static/media/vault-logo.b825f783.svg";